'use client'

import { Spinner, useLocale } from '@rewardops/ui'
import { type Page } from '@rewardops/utils'

import { useApi } from '../hooks/use-api'
import { useContentfulSectionFilter } from '../hooks/use-contentful-section-filter'
import NotFound from '../not-found/not-found'
import Section from './section'

type Props = {
  content?: Page
  id?: string
}

type PropsById = {
  pageId: string
}

export function ContentfulPage({ content, id }: Props) {
  const filteredSections = useContentfulSectionFilter({
    sections: content?.sections,
  })

  return (
    <div
      className="grid w-full grid-flow-row-dense grid-cols-2"
      id={`page-${id}`}
    >
      {filteredSections?.map((section) => (
        <Section content={section} key={section.id} />
      ))}
    </div>
  )
}

export function ContentfulPageById({ pageId }: PropsById) {
  const { api, tenant } = useApi()
  const { data: _ } = api.contentful.syncData.useQuery({
    languages: tenant.locale.supported,
  })
  const { locale } = useLocale()

  const {
    data: contentful,
    isLoading,
  }: { data: Page | undefined; isLoading: boolean } =
    api.contentful.getById.useQuery({
      key: pageId,
      language: locale,
      type: 'page',
    })

  if (isLoading) {
    return <Spinner className="mx-auto mt-4" />
  }

  if (!isLoading && !contentful) {
    return <NotFound />
  }

  return <ContentfulPage content={contentful} id={pageId} />
}
